import { render } from "./InventoryList.vue?vue&type=template&id=9ff43a6a"
import script from "./InventoryList.vue?vue&type=script&lang=js"
export * from "./InventoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__